import { Component, inject } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { companies, companiesFinanciero, companiesReportesNorm, companiesRiesgoCredito, companiesRiesgoLiquidez, companiesSegPresupuestal  } from '../../shared/catalogos';
import { ContenedorService } from '../../services/contenedor/contenedor.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { ArraysOrder } from '../funciones/funcionesGenerales';
import { messages } from '../funciones/mensajes';
import { Apollo } from 'apollo-angular';
import { getAsignacionesInst, getCuestionarioPorId, getEstatusHoja, getHojaRespuesta } from '../../services/Administrador/cuestionarios/query';
import { SecureCookiesService } from '../../services/encript/secure-cookies.service';
import { environment } from '../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { PlanificacionService } from '../../services/gestion/planificacion/planificacion.service';


@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.css'
})
export class InicioComponent {
  modulesAct = [];

  private access = [];
  private url: any;
  public planning = [];
  private planingId = 0;
  private selectPlannig: any = ''
  private allocations = [];


  #dataService = inject(DataService);
  #router = inject(Router);
  #translate = inject(TranslateService);
  #apollo = inject(Apollo);
  #secureCookies = inject(SecureCookiesService);
  
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));  

  constructor(
    private cookies: CookieService,
    private rutaActual: ActivatedRoute,
    private contenedorService: ContenedorService,
    private activeRoute: ActivatedRoute,
    private planificacionService: PlanificacionService,
  ){
    this.menu();

  }
  private menu(){
    var aux = [];
    for(const mod of this.#dataService.modulesUser){
      if(mod.name !== 'Inicio' && mod.submodules.length >0){
        aux.push(mod);
      }
    }
    this.modulesAct = aux;
  }
  // Separación por plataformas
  public isFirstModule(pos){
    if(pos === 0 ){
      return true
    }else if(this.modulesAct[pos].platform !== this.modulesAct[pos-1].platform){
      return true;
    }
    return false;
  }
  // Envio de rutas
  send(route){
    const mod = route.submodules[0].route.split('/')[0];
    
    if(mod === 'operative' || mod === 'operative-potencial'){
      this.cookies.delete('idInstitucion','/');
      this.sendToOperative(route);
    }else if(mod === 'riesgo-credito'){
      this.cookies.delete('idInstitucion','/');
      this.sendToRiesgoCredito(route);
    } else if(mod === 'financiero-alerta'){
      this.cookies.delete('idInstitucion','/');
      this.sendToFinancieroAlerta(route);
    } else if(mod === 'formulacion' || mod === 'seguimiento' || mod === 'reportes' || mod === 'administrador-gestion'){
      this.cookies.delete('idInstitucion','/');
      this.sendToGestionEstrategica(route);
    } else if(route.module === 'resultados'){
      this.cookies.delete('idInstitucion','/');
      this.sendToResultados(route);
    } else if(route.module === 'clima-laboral'){
      this.cookies.delete('idInstitucion','/');
      this.sendToClimaLaboral(route);
    } else if(mod == 'proyecciones-financieras'){
      this.cookies.delete('idInstitucion','/');
      this.sendToProyecciones(route);
    } else if(mod == 'seguimiento-presupuestal'){
      this.cookies.delete('idInstitucion','/');
      this.sendToSegPresupuestal(route);
    }else if(route.module === 'riesgo-liquidez'){
        this.cookies.delete('idInstitucion','/');
        this.sendToRiesgoLiquidez(route); 
    }else if(route.module === 'reportes-normativos'){
        this.cookies.delete('idInstitucion','/');
        this.sendToReportesNormativos(route); 
    }else{
      this.cookies.delete('idInstitucion','/');
      this.#router.navigateByUrl('app/'+route.submodules[0].route);
    }
  }
  // Envio plataforma operartivo
  async sendToOperative(route){
    if(this.#dataService.role.toLowerCase().includes('administrador')){
      if(this.cookies.get('idInstitucion') === ''){
        var inst = [];
        for(const c of companies){
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.set('idInstitucion',companies[result].id, {path: '/'});
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
      }else{
        this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
    }else{
      if(this.cookies.get('idInstitucion') === ''){
        this.cookies.set('idInstitucion',this.#dataService.idInstitution, {path: '/'});
      }
      this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
    }
  }
  // Envio plataforma riesgos
  async sendToRiesgoCredito(route){
    if(this.#dataService.role.toLowerCase().includes('administrador')){
      if(this.cookies.get('idInstitucion') === ''){
        var inst = [];
        for(const c of companiesRiesgoCredito){
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.set('idInstitucion',companiesRiesgoCredito[result].id, {path: '/'});
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
      }else{
        this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
    }else{
      if(this.cookies.get('idInstitucion') === ''){
        const ex = companiesRiesgoCredito.find(c => c.idAdmin === this.#dataService.idInstitution);
        if(ex){
          this.cookies.set('idInstitucion',ex.id, {path: '/'});
        }
      }
      this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
    }
  }
  async sendToFinancieroAlerta(route){
    if(this.#dataService.role.toLowerCase().includes('administrador')){
      if(this.cookies.get('idInstitucion') === ''){
        var inst = [];
        for(const c of companiesFinanciero){
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.set('idInstitucion',companiesFinanciero[result].id, {path: '/'});
          this.cookies.set('idPlanFin',companiesFinanciero[result].idPlantilla, {path: '/'});
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
      }else{
        this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
    }else{
      if(this.cookies.get('idInstitucion') === ''){
        const ex = companiesFinanciero.find(c => c.idAdmin === this.#dataService.idInstitution);
        if(ex){
          this.cookies.set('idInstitucion',ex.id, {path: '/'});
          this.cookies.set('idPlanFin',''+ex.idPlantilla, {path: '/'});
        }
      }
      this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
    }
  }
  // Envio plataforma gestion
  async sendToGestionEstrategica(route){
    await this.getAccess();
    if(route.module !== 'administrador-gestion'){
      messages.messageSaving(this.#translate.instant('acciones.espera'), '');
      const res = await this.planificacionService.getPlanificacionesGQLMenu();

      this.planning = [];
      for(const plan of res){
        if(this.planAccess(plan.institution.id)){
          this.planning.push({
            id: plan.id,
            name: plan.name,
          });
        }
      }
      this.planning = ArraysOrder.orderNumber(this.planning, 'id')
      var plans: any = [];
      for(const plan of this.planning){
        plans.push(`${plan.name}`);
      }
      Swal.close();
      if(plans.length >0){
        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          plans,
          this.#translate
        );
        if (result) {
          this.planingId = Number(this.planning[Number(result)].id);
          this.selectPlannig = this.planning[Number(result)].name;

          this.cookies.set('idInstitucion',`${this.planingId}` , {path: '/'});
          this.cookies.set('nombreInstitucion',this.selectPlannig, {path: '/'});
          this.#router.navigateByUrl(`app/${route.submodules[0].route}`);
        }
      }else{
        messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
      }
    } else{
      messages.messageSaving(this.#translate.instant('acciones.espera'), '');
      const response = await firstValueFrom(this.contenedorService.getInstitutions());
      this.planning = [];
      for(const inst of response){
        if(this.planAccess(inst.id)){
          if(this.planAccess(inst.id) && (inst.code === this.#dataService.idInstitution || this.#dataService.role === 'Administrador')){
            this.planning.push({
              id: inst.id,
              name: inst.name,
            });
          }
        }
      }
      this.planning = ArraysOrder.orderNumber(this.planning, 'id');

      var plans: any = [];
      for(const plan of this.planning){
        plans.push(`${plan.name}`);
      }
      Swal.close();
      if(plans.length > 0){
        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          plans,
          this.#translate
        );
        if (result) {
          this.planingId = Number(this.planning[Number(result)].id);
          this.selectPlannig = this.planning[Number(result)].name;

          this.cookies.set('idInstitucion',`${this.planingId}` , {path: '/'});
          this.cookies.set('nombreInstitucion',this.selectPlannig, {path: '/'});
          this.#router.navigateByUrl(`app/${route.submodules[0].route}`);
        }
      }else{
        messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
      }      
    }
  }
  // Envio resultados
  private async sendToResultados(modulo){
    messages.messageSaving(this.#translate.instant('acciones.espera'),'')
    try{
      const allocations = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
          }).valueChanges.source
      );
  
      const arrayAllocations = allocations.data.availableSurveys; 
      this.allocations = [];
      var nameAlloc = [];
      for(const all of arrayAllocations){
        if(this.#dataService.role === 'Rol_Administrador_cuestionarios' || all.institution_id === this.#dataService.idInstitution){
          try{
            const answerSheet = await firstValueFrom(
              this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
                query: getEstatusHoja,
                context: { headers: this.headers, },
                variables: { allocationId: Number(all.id)},
                fetchPolicy: 'no-cache',
              }).valueChanges.source 
            );
      
            if(answerSheet.data.findAnswerSheet.status === 'completed' || all.status === 'closed'){
              this.allocations.push(all);
              nameAlloc.push(all.questionary.name);
            }
    
          }catch(err){}
        }
      }
      var guardo = false;
  
      if(this.allocations.length === 0){
        Swal.close();
        setTimeout(() =>{
          messages.infoMessageGraph( this.#translate.instant('cues.resultados.no-informacion') );
        }, 100);
        return;
      }

      const result = await messages.select(
        this.#translate.instant('acciones.seleccione-cuestionario'),
        nameAlloc,
        this.#translate
      );
      if (result) {
        this.cookies.set('nombreInstitucion',nameAlloc[result], {path: '/'});
        guardo = true;
      }

      if(guardo){
        messages.messageSaving(this.#translate.instant('acciones.espera'),this.#translate.instant('acciones.cargando'))
        try{
          const res = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getHojaRespuesta,
              context: { headers: this.headers, },
              variables: { allocationId: Number(this.allocations[result].id) }
            }).valueChanges.source
          );
    
          var answersSheet = [];
          for(const r of res.data.findAnswerSheet.answers){
            answersSheet.push({idQuestion: r.question.id, idAnswer: r.answerOption.id})
          }
    
          const res2 = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getCuestionarioPorId,
              context: { headers: this.headers, },
              fetchPolicy: 'no-cache',
              variables: {
                args: {
                  relations: {
                    loadRelations: "FULL"
                  },
                  filter: {
                    operator: "AND",
                    conditions: [
                      {
                        field: "id",
                        operator: "EQUAL",
                        value: ""+this.allocations[result].questionary.id
                      }
                    ]
                  },
                },
              }
            }).valueChanges.source
          );
          localStorage.setItem('answers', JSON.stringify(answersSheet));
          localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
          localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));

          Swal.close();

          this.#router.navigateByUrl('/app/'+ modulo.submodules[0].route);

    
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  private async sendToClimaLaboral(modulo){
    messages.messageSaving(this.#translate.instant('acciones.espera'), '')
    try{
      const allocations = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
        }).valueChanges.source
      );
      const arrayAllocations = allocations.data.availableSurveys;
      this.allocations = [];
      var nameAlloc = [];
      for(const all of arrayAllocations){
        //los cuestionarios de encuestas de ambiente y clima laboral no se muestran en este modulo(clima laboral)
        //caso especial para el rol Administrador_Planeacion_ClimaLaboral que puede ver todos los cuestionarios de clima laboral
        if(
          (this.#dataService.role === 'Administrador_AleemaRemake'|| this.#dataService.role==='Administrador_Planeacion_ClimaLaboral' || all.institution_id === this.#dataService.idInstitution) &&
          all.questionary.allowMultipleAnswers && all.status === 'closed' && !all.questionary.name.toLowerCase().includes('encuesta de ambiente y clima laboral')){
          try{
            this.allocations.push(all);
            nameAlloc.push(all.questionary.name);
    
          }catch(err){}
        }
      }
      var guardo = false;
      if(this.allocations.length === 0){
        Swal.close();
        setTimeout(() =>{
          messages.infoMessageGraph( this.#translate.instant('cues.resultados.no-informacion') );
        }, 100);
        return;
      }

      const result = await messages.select(
        this.#translate.instant('acciones.seleccione-cuestionario'),
        nameAlloc,
        this.#translate
      );
      if (result) {
        this.cookies.set('nombreInstitucion',nameAlloc[result], {path: '/'});
        guardo = true;
      }
      
      if(guardo){
        messages.messageSaving(this.#translate.instant('acciones.espera'),this.#translate.instant('acciones.cargando'))
        try{
          //TODO: Traer hojas de respuesta
          // const res = await firstValueFrom(
          //   this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          //     query: getHojaRespuesta,
          //     context: { headers: this.headers, },
          //     variables: { allocationId: Number(this.allocations[inputValue.value].id) }
          //   }).valueChanges.source
          // );
    
          // var answersSheet = [];
          // for(const r of res.data.findAnswerSheet.answers){
          //   answersSheet.push({idQuestion: r.question.id, idAnswer: r.answerOption.id})
          // }
    
          const res2 = await firstValueFrom(
            this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getCuestionarioPorId,
              context: { headers: this.headers, },
              fetchPolicy: 'no-cache',
              variables: {
                args: {
                  relations: {
                    loadRelations: "FULL"
                  },
                  filter: {
                    operator: "AND",
                    conditions: [
                      {
                        field: "id",
                        operator: "EQUAL",
                        value: ""+this.allocations[result].questionary.id
                      }
                    ]
                  },
                },
              }
            }).valueChanges.source
          );
          // localStorage.setItem('answers', JSON.stringify(answersSheet));
          localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
          localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));

          Swal.close();

          this.#router.navigateByUrl('/app/'+ modulo.submodules[0].route);

    
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }catch(err){
      messages.errorMessageGraph(err)
    }
  }
  // Envio plataforma proyecciones
  async sendToProyecciones(route){
    this.#router.navigateByUrl(`app/${route.submodules[0].route}`);

  }
  private async getAccess(){
    const res = await firstValueFrom(
      this.contenedorService.getAccess(this.#dataService.user)
    );
    
    if(res){
      this.access = [];
      for(const acc of res.access){
        this.access.push(`${acc}`);
      }
      if ( res.access.length === 0){
        this.access = ['all']
      }
    }else{
      this.access = ['no encontrado']
    }
    this.url = this.activeRoute.snapshot['url'];
    var params = this.activeRoute.snapshot['params'];
    if(this.url.length !== 1 && this.url.length !== 0){
      this.planingId = params['idPlanning'];
      this.selectPlannig = params['namePlanning']; 
    }
  }
  private planAccess(id: any){
    if ( this.access[0] === 'all' || this.access.includes(id) || this.access[0] === 'no encontrado'){
      return true;
    }
    return false;
  }

// Envio plataforma riesgo-liquidez
  private async sendToRiesgoLiquidez(route){
    // LOG 1: Inicio de la función y datos principales
    if(this.#dataService.role.toLowerCase().includes('administrador')){
        // LOG 2: Bloque Administrador
        if(this.cookies.get('idInstitucion') === ''){
            // LOG 3: Cookie vacía en modo Administrador
            var inst = [];
            for(const c of companiesRiesgoLiquidez){ 
                inst.push(c.name)
            }

            const result = await messages.select(
              this.#translate.instant('swal.seleccione-institucion'),
              inst,
              this.#translate
            );
            if (result) {
              this.cookies.set('idInstitucion',companiesRiesgoLiquidez[result].id, {path: '/'});
              this.cookies.set('idPlanFin',companiesRiesgoLiquidez[result].idPlantilla, {path: '/'});
              // LOG 5: Navegación después de seleccionar institución
              this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
            }
        }else{
            this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
    }else{
        if(this.cookies.get('idInstitucion') === ''){
            const ex = companiesRiesgoLiquidez.find(c => c.idAdmin === this.#dataService.idInstitution);

              if(ex){
                  this.cookies.set('idInstitucion',ex.id, {path: '/'});
                  this.cookies.set('idPlanFin',''+ex.idPlantilla, {path: '/'});
              }else{
                  this.cookies.set('idInstitucion',this.#dataService.idInstitution, {path: '/'});
              }
          } else {
          }
          
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
  }

  private async sendToSegPresupuestal(route){
    if(this.#dataService.role.toLowerCase().includes('administrador')){
      if(this.cookies.get('idInstitucion') === ''){
        var inst = [];
        for(const c of companiesSegPresupuestal){
          inst.push(c.name)
        }

        const result = await messages.select(
          this.#translate.instant('swal.seleccione-institucion'),
          inst,
          this.#translate
        );
        if (result) {
          this.cookies.set('idInstitucion',companiesSegPresupuestal[result].id, {path: '/'});
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
      }else{
        this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
    }else{
      if(this.cookies.get('idInstitucion') === ''){
        const ex = companiesSegPresupuestal.find(c => c.id === this.#dataService.idInstitution);
        if(ex){
          this.cookies.set('idInstitucion',ex.id, {path: '/'});
        }
      }
      this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
    }
  }
  private async sendToReportesNormativos(route){
    // LOG 1: Inicio de la función y datos principales
    if(this.#dataService.role.toLowerCase().includes('administrador')){
        // LOG 2: Bloque Administrador
        if(this.cookies.get('idInstitucion') === ''){
            // LOG 3: Cookie vacía en modo Administrador
            var inst = [];
            for(const c of companiesReportesNorm){ 
                inst.push(c.name)
            }

            const result = await messages.select(
              this.#translate.instant('swal.seleccione-institucion'),
              inst,
              this.#translate
            );
            if (result) {
              this.cookies.set('idInstitucion',companiesReportesNorm[result].id, {path: '/'});
              this.cookies.set('idPlanFin',companiesReportesNorm[result].idPlantilla, {path: '/'});
              // LOG 5: Navegación después de seleccionar institución
              this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
            }
        }else{
            this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
        }
    }else{
        if(this.cookies.get('idInstitucion') === ''){
            const ex = companiesReportesNorm.find(c => c.idAdmin === this.#dataService.idInstitution);

              if(ex){
                  this.cookies.set('idInstitucion',ex.id, {path: '/'});
                  this.cookies.set('idPlanFin',''+ex.idPlantilla, {path: '/'});
              }else{
                  this.cookies.set('idInstitucion',this.#dataService.idInstitution, {path: '/'});
              }
          } else {
          }
          
          this.#router.navigateByUrl('/app/'+ route.submodules[0].route);
      }
  }

}
